import React from "react";
import "./FileListReorder.css";

export default function FileListReorder({ files, onReorder, onRemove }) {
  return (
    <div className="flr">
      {files.map((f, i) => (
        <div
          key={`${f.name}-${i}`}
          className="flr-row"
          draggable
          onDragStart={(e) => e.dataTransfer.setData("text/plain", String(i))}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            const from = Number(e.dataTransfer.getData("text/plain"));
            const to = i;
            if (!Number.isNaN(from) && from !== to) onReorder(from, to);
          }}
        >
          <div className="flr-left">
            <div className="flr-name">
              {i + 1}. {f.name}
            </div>
            <div className="flr-sub">
              {(f.size / 1024 / 1024).toFixed(2)} Mo
            </div>
          </div>

          <div className="flr-actions">
            <button onClick={() => onReorder(i, i - 1)} disabled={i === 0}>
              ↑
            </button>
            <button
              onClick={() => onReorder(i, i + 1)}
              disabled={i === files.length - 1}
            >
              ↓
            </button>
            <button onClick={() => onRemove(i)}>Retirer</button>
          </div>
        </div>
      ))}
    </div>
  );
}
